import { AGREEMENT_TYPE } from '@/schemas/order';
import { request } from './request';
import { ApiConfigs, Response } from '../schemas/service';

const api: ApiConfigs = {
  checkAgreementTip: {
    url: '/health/api/v1/agreement/checkAgreementTip',
    method: 'GET'
  },
  confirmAgreement: {
    url: '/health/api/v1/agreement/confirmAgreement',
    method: 'GET'
  },
  checkGroupAgreementTip: {
    url: '/health/api/v1/agreement/checkGroupAgreementTip',
    method: 'GET'
  }
};

interface IQuery {
  productType: AGREEMENT_TYPE;
  userId?: number;
}

interface IQueryOfGroup {
  productType: AGREEMENT_TYPE;
  doctorId?: number;
}

const agreement = {
  async checkAgreementTip({ productType, userId }: IQuery) {
    try {
      const response: Response<boolean> = await request(api.checkAgreementTip, {
        productType,
        userId
      });
      const { result } = response; // true表示要弹窗
      return !result;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async confirmAgreement({ productType, userId }: IQuery) {
    try {
      const response: Response<boolean> = await request(
        api.confirmAgreement,
        {
          productType,
          userId
        },
        undefined,
        { hideGlobalLoading: false }
      );
      const { result } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async checkGroupAgreementTip({ productType, doctorId }: IQueryOfGroup) {
    try {
      const response: Response<boolean> = await request(
        api.checkGroupAgreementTip,
        {
          productType,
          doctorId
        },
        undefined,
        { hideGlobalLoading: false }
      );
      const { result } = response; // true表示要弹窗
      if (result == null) {
        return Promise.reject(new Error('result is null'));
      }
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

export default agreement;
